import { Injectable } from '@angular/core';

enum NormalizationForm {
    CANONICAL_DECOMPOSITION = 'NFD'
}

/**
 * @ngdoc service
 * @name ApDiacriticsNormalizeService
 */
@Injectable()
export class ApDiacriticsNormalizeService {
    public normalize(value: string): string {
        if (!value) {
            return value;
        }
        return value
            .normalize(NormalizationForm.CANONICAL_DECOMPOSITION)
            .split('')
            .filter((char) => char.charCodeAt(0) < 128)
            .join('');
    }
}
